<template>
  <div
    class="button-group"
    v-if="l_visible"
    :class="{ readonly: readonly || getDisabled || isLoading }"
  >
    <div class="button-group-label" v-if="getLabel && labelVisible">
      {{ getLabel }} <span v-if="showRequired" class="text-required"></span>

      <v-tooltip v-if="!!getTooltip" slot="append" bottom max-width="350">
        <template #activator="{ on }">
          <v-icon slot="activator" class="btn-help text-body-2 ml-2" v-on="on"
            >mdi-help-circle</v-icon
          >
        </template>
        <span> {{ getTooltip }} </span>
      </v-tooltip>
    </div>
    <v-btn-toggle
      ref="btnToggle"
      :value="l_value"
      v-bind:class="{
        'row button-group-select': select,
        'button-group-switch': switchBtn,
        'button-group-chip': chip,
      }"
      class="button-group"
      :mandatory="mandatory"
      group
      :multiple="multiple && (select || chip)"
      @change="onChange"
      :max="max"
    >
      <template v-if="select">
        <v-col cols="12" xl="3" lg="3" md="6" sm="12" v-for="(item, index) in l_data" :key="index">
          <v-btn
            :value="item.valueMember"
            :disabled="getDisabled"
            outlined
            class="pa-0"
            :key="index"
          >
            {{ item.displayMember }}
          </v-btn>
        </v-col>
      </template>
      <template v-if="switchBtn || chip">
        <template v-for="(item, index) in l_data">
          <template v-if="item.popis != '' && item.popis != null">
            <v-tooltip top :key="index" :open-delay="500" max-width="350">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    :key="index"
                    :value="item.valueMember"
                    :small="small"
                    :disabled="getDisabled || isItemDisabled(item)"
                    v-bind:class="{
                      'pa-0': switchBtn,
                    }"
                  >
                    {{ item.displayMember }}
                    <v-icon v-if="chip" right dark size="14"> mdi-check </v-icon>
                  </v-btn>
                </div>
              </template>
              <span>{{ item.popis }}</span>
            </v-tooltip>
          </template>
          <template v-else>
            <v-btn
              :key="index"
              :value="item.valueMember"
              :small="small"
              :disabled="getDisabled || isItemDisabled(item)"
              v-bind:class="{
                'pa-0': switchBtn,
              }"
            >
              {{ item.displayMember }}
              <v-icon v-if="chip" right dark size="14"> mdi-check </v-icon>
            </v-btn>
          </template>
        </template>
      </template>
    </v-btn-toggle>
    <div class="button-group-info" v-if="info">
      {{ info }}
    </div>
  </div>
</template>
<script>
import { dynamicControlMixin } from '../../mixins/dynamicControlMixin';

export default {
  watch: {
    value(val) {
      if (val !== this.l_value) {
        this.setDirty(true);
        this.update(val);
      }
    },
  },
  mixins: [dynamicControlMixin],
  props: {
    multiple: Boolean,
    switchBtn: Boolean,
    select: Boolean,
    chip: Boolean,
    items: Array,
    value: [String, Number, Array],
    small: Boolean,
    label: String,
    info: String,
    mandatory: {
      type: Boolean,
      default: true,
    },
    max: Number,
    disabled: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
    showRequired: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      l_value: null,
      viewObjectText: null,
      viewObjectInfoText: null,
      l_data: [],
      labelVisible: true,
    };
  },
  computed: {
    getDisabled() {
      return this.disabled || this.isDisabled;
    },
  },
  methods: {
    onChange(val) {
      if (this.multiple && this.l_value != null && this.l_value.length > 0 && val != null) {
        let isClose = false;
        let uniqueValue = null;
        let uniqueValueIndex = null;

        if (this.l_value.length > val.length) {
          uniqueValue = this.l_value.filter(item => !val.includes(item));
          uniqueValueIndex = this.l_data.findIndex(item => item.valueMember == uniqueValue[0]);
          let min = Number.MAX_SAFE_INTEGER;
          let max = 0;
          for (let i = 0; i < this.l_value.length; i++) {
            let dataIndex = this.l_data.findIndex(item => item.valueMember == this.l_value[i]);
            if (min >= dataIndex) {
              min = dataIndex;
            }
            if (max <= dataIndex) {
              max = dataIndex;
            }
          }
          if (min != Number.MAX_SAFE_INTEGER && (max != 0 || val.length == 0)) {
            if (uniqueValueIndex == min || uniqueValueIndex == max) {
              isClose = true;
            }
          }
        } else {
          let arrayIndexov = [];
          for (let i = 0; i < val.length; i++) {
            arrayIndexov.push(this.l_data.findIndex(item => item.valueMember == val[i]));
          }
          arrayIndexov.sort(function (a, b) {
            return a - b;
          });

          let index = arrayIndexov[0] - 1;
          for (let i = 0; i < arrayIndexov.length; i++) {
            if (i + 1 <= arrayIndexov.length) {
              if (index + 1 != arrayIndexov[i]) {
                for (let u = index + 1; u < arrayIndexov[i]; u++) {
                  val.push(this.l_data[u].valueMember);
                }
              }
              index = arrayIndexov[i];
            }
          }
          isClose = true;
          // uniqueValue = val.filter(item => !this.l_value.includes(item));
          // uniqueValueIndex = this.l_data.findIndex(item => item.valueMember == uniqueValue[0]);
          // for (let i = 0; i < this.l_value.length > 0; i++) {
          //   let index = this.l_data.findIndex(item => item.valueMember == this.l_value[i]);
          //   if (uniqueValueIndex == index + 1 || uniqueValueIndex == index - 1) {
          //     isClose = true;
          //     break;
          //   }
          // }
        }

        if (isClose) {
          this.setDirty(true);
          this.update(val);
        } else {
          this.$refs.btnToggle.internalLazyValue = this.l_value;
        }
      } else {
        this.setDirty(true);
        this.update(val);
      }
    },
    update(val) {
      this.l_value = val;
      this.$emit('input', val);
      if (this.dirty) {
        let value = this.l_value;
        if (this.multiple) {
          if (!!this.l_value && this.l_value.length > 0) {
            let min = Number.MAX_SAFE_INTEGER;
            let max = 0;
            for (let i = 0; i < this.l_value.length; i++) {
              let dataRozsahy = this.l_value[i].split(',');
              let valueMin = parseInt(dataRozsahy[0]);
              let valueMax = parseInt(dataRozsahy[1]);
              if (min >= valueMin) {
                min = valueMin;
              }
              if (max <= valueMax) {
                max = valueMax;
              }
              if (min != Number.MAX_SAFE_INTEGER && max != 0) {
                value = min + ',' + max;
              }
            }
          }
        }
        if (this.l_value?.length == 0) {
          this.l_value = null;
        }
        this.saveValue(value);
      }
    },
    readData(config, data) {
      this.viewObjectText = config.viewObjectText;
      this.viewObjectInfoText = config.viewObjectInfoText;
      if (this.l_data.length === 0) {
        this.l_data = data;

        if (!data) {
          let i = 0;
          this.l_data = this.viewObjectText.split('#').map(o => {
            //toto vymyslel Skyfko ze pri jednoduchych prepinacoch dat tie moznosti do nazvu oddelene #
            let curr = {
              valueMember: i,
              displayMember: o,
            };
            i++;
            if (!this.staticLabel) this.labelVisible = false;
            return curr;
          });
        }
      }

      if (config.controlValue !== null && config.controlValue !== undefined) {
        if (this.multiple) {
          this.l_value = [];
          let rozsahy = config.controlValue.split(',');
          let min = parseInt(rozsahy[0]);
          let max = parseInt(rozsahy[1]);
          for (let i = 0; i < this.l_data.length; i++) {
            let dataRozsahy = this.l_data[i].valueMember.split(',');
            if (min <= parseInt(dataRozsahy[0]) && max >= parseInt(dataRozsahy[1])) {
              this.l_value.push(this.l_data[i].valueMember);
            }
          }
        } else {
          this.l_value = config.controlValue;
        }
        this.$emit('input', this.l_value);
      }
    },
    getValue() {
      return this.l_value;
    },
    isItemDisabled(item) {
      if (item?.is_enabled != null) {
        return !item?.is_enabled ? true : false;
      } else {
        return false;
      }
    },
  },
  created() {
    if (this.multiple) {
      this.l_value = [];
    }
    if (!this.dynamic) {
      if (this.items) this.l_data = this.items;
    }

    if (this.value) this.l_value = this.value;
  },
  mounted() {
    if (!this.data_id && this.data.length > 0) {
      this.l_data = this.data;
    }
  },
};
</script>
